module.exports = __webpack_public_path__ + "static/hole-47a307b201db9058a76f435f85b9e793.webm";